import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController,
  ModalController
} from "ionic-angular";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import { AuthProvider } from "../../providers/auth/auth";
import * as moment from "moment";
import { SurveyPage } from "../survey/survey";
import { AngularFirestore } from "angularfire2/firestore";

@IonicPage()
@Component({
  selector: "page-studies",
  templateUrl: "studies.html"
})
export class StudiesPage {
  public studyList: Observable<any[]>;
  public doctorList: Observable<any[]>;
  public medList: Observable<any[]>;
  clinic_name: string;
  clinic_id: string;
  filter: string;
  public clinic: any;

  public studystatus = [{id: 'enrolled', name: 'Enrolled'},{id: 'notenrolled', name: 'Not Enrolled'},{id: 'cancelled', name: 'Cancelled'}];
  status: string = "enrolled";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private afs: AngularFirestore
  ) {
    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.database.getClinic(this.clinic_id).valueChanges().subscribe((clinic) => {
        if(clinic)  {
          this.clinic = clinic;
          console.log("Full Clinic Info: ", this.clinic)
        }
      });

      this.getStudies();
    });
  }

  ionViewDidLoad() {}

  public formatDate(date) {
    let myMoment: moment.Moment
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format("YYYY MMM DD");
  }

  CompleteStudy(study)  {

    let studydata = {
      clinic: this.clinic,
      patient: study.patient,
      doctor: study.doctor,
      medication: study.medication,
      study: study.study,
      renewal: false
    };

    let studyModal = this.modalCtrl.create(SurveyPage, studydata, {cssClass: 'select-modal', enableBackdropDismiss: false });
    studyModal.onDidDismiss(data => {
      console.log(data)
      if(data['completed'])  {
        this.database.completeStudy(study.id, this.clinic_id, data.patient_id, data)
      }      
    });
    studyModal.present();
  }

  public getStudies() {
    let status: string = null;
    status = this.status;
    this.studyList = this.afs.collection(`clinics/${this.clinic_id}/studyresults`, ref => {
      let query : firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      if(status === 'enrolled' || status === 'notenrolled' || status === 'cancelled') query = query.where('_status', '==', status);
      return query.orderBy("createdAt", "desc");
    })
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      });
    });
  }

 getStudyList()  {
    this.studyList = this.database
        .getStudiesByClinic(this.clinic_id)
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        });
  }

  filterChanged(ev) {
    this.getStudyList();
  }

  segmentChanged(ev)  {
    this.status = ev.value;
    this.getStudies();
  }
}



// WEBPACK FOOTER //
// ./src/pages/studies/studies.ts